import React from 'react'
import { DistributionChart } from './d3-charts/distribution-chart'

// let distribchart = null;
// let distdata = null;

class DistChart extends React.Component {
  constructor (props) {
    super(props)
    this.format = this.format.bind(this)
    this.loadEmptyData = this.loadEmptyData.bind(this)
    this.loadSampleData = this.loadSampleData.bind(this)
    this.loadRandomValue = this.loadRandomValue.bind(this)

    // getinitialState
    this.state = {
      defaultData: props.data,
      chart: null
    }
  }

  componentDidMount () {
    const _this = this
    const { label } = this.props

    let distdata = this.state.defaultData

    let settings = {
      el: 'distChart' + label,
      margin: { top: 0, right: 0, bottom: 0, left: 0 }
    }
    _this.distribchart = new DistributionChart()
    _this.distribchart.create(settings).then(function () {
      _this.distribchart.update(_this.format(distdata))
    })
  }

  format (data) {
    // No adaptation needed
    return data
  }

  loadEmptyData () {
    const _this = this

    let distdata = this.state.defaultData
    _this.distribchart.update(this.format(distdata))
  }

  loadSampleData () {
    // distribchart.update(this.format(sampleData));
  }

  loadRandomValue () {
    const _this = this

    _this.distribchart.randomValue()
  }

  render () {
    const { label } = this.props

    return (
      <div className="dist-chart chart-wrapper">
        <div id={'distChart' + label} className="distribution-chart" />
      </div>
    )
  }
}

export default DistChart
